
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18.55 18.55"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"1","y":"1","width":"16.55","height":"16.56","rx":"2","fill":"#fff"}}),_c('path',{attrs:{"d":"M15.56 2a1 1 0 011 1v12.56a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1h12.56m0-2H3a3 3 0 00-3 3v12.56a3 3 0 003 3h12.56a3 3 0 003-3V3a3 3 0 00-3-3z","fill":"#7b7b7b"}})])
          )
        }
      }
    